// removed by extract-text-webpack-plugin
module.exports = {"Modal":"modal__Modal__3HyXS","Close":"modal__Close__1HaRk","Description":"modal__Description__S3VOB","Message":"modal__Message__2d1FD","Error":"modal__Error__2U00s","Row":"modal__Row__1qBbo","Or":"modal__Or__tStYE"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Modal/modal.css
// module id = 63
// module chunks = 2